module.exports = __webpack_public_path__ + "img/hb_img04.d765277a.png";